import React, { createContext, useContext, useState, useEffect } from 'react';
import AOS from 'aos/dist/aos';

const RTLContext = createContext();

export function RTLProvider({ children }) {
  // Initialize state from localStorage or default to false
  const [isRTL, setIsRTL] = useState(() => {
    const saved = localStorage.getItem('isRTL');
    return saved ? JSON.parse(saved) : false;
  });

  // Save to localStorage whenever isRTL changes
  useEffect(() => {
    localStorage.setItem('isRTL', JSON.stringify(isRTL));
  }, [isRTL]);

  useEffect(() => {
    // Update document direction when RTL state changes
    document.documentElement.dir = isRTL ? 'rtl' : 'ltr';

    // Reinitialize AOS with new direction
    AOS.init({
      once: true,
      duration: 1000,
      easing: 'ease-out-cubic',
      offset: 50,
      delay: 0,
      mirror: false,
      anchorPlacement: 'top-bottom',
    });
  }, [isRTL]);

  const toggleRTL = () => {
    setIsRTL(prev => !prev);
  };

  return (
    <RTLContext.Provider value={{ isRTL, setIsRTL, toggleRTL }}>
      {children}
    </RTLContext.Provider>
  );
}

export function useRTL() {
  const context = useContext(RTLContext);
  if (!context) {
    throw new Error('useRTL must be used within an RTLProvider');
  }
  return context;
} 